export default __webpack_public_path__ + "8ba56e1c4ba7d90c9ca9d10fc6465407.svg";